/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { transferCustomersControllerGetCustomer } from "./transferCustomersControllerGetCustomer";
import { transferCustomersControllerGetCustomerOfficeAdmins } from "./transferCustomersControllerGetCustomerOfficeAdmins";
import { transferCustomersControllerGetMigrationPreferences } from "./transferCustomersControllerGetMigrationPreferences";
import { transferCustomersControllerGetTeamTree } from "./transferCustomersControllerGetTeamTree";
import { transferCustomersControllerListCustomers } from "./transferCustomersControllerListCustomers";
import { transferCustomersControllerTriggerClassification } from "./transferCustomersControllerTriggerClassification";
import { transferCustomersControllerTriggerSync } from "./transferCustomersControllerTriggerSync";
import { transferCustomersControllerUpdateMigrationPreferences } from "./transferCustomersControllerUpdateMigrationPreferences";

export function transferCustomersService() {
  return { transferCustomersControllerTriggerSync, transferCustomersControllerTriggerClassification, transferCustomersControllerListCustomers, transferCustomersControllerGetCustomer, transferCustomersControllerGetCustomerOfficeAdmins, transferCustomersControllerGetMigrationPreferences, transferCustomersControllerUpdateMigrationPreferences, transferCustomersControllerGetTeamTree }
}